import React from 'react';
import { StyleSheetManager, createGlobalStyle } from 'styled-components';
import { getBrandTheme } from './motifs';

import { theme } from './global';
import { styles } from './styles';
import { TPublication } from '../models/Publications';

type TGlobalStyles = {
    publicationID: TPublication;
}

const GlobalStyles = createGlobalStyle<TGlobalStyles>`
    /* base styles */
    ${styles.base}
    ${styles.typography}

    :root {
        /* base theme */
        ${theme.colors}
        ${theme.typography}
        ${theme.general}
        ${theme.components}
        ${theme.pages}
    }

    #apply-mypage-brand-theme {
        /* pages and components to use brandTheme(baseTheme) */
        ${theme.components}
        ${theme.pages}

        /* brand theme - overwrites base theme*/
        ${({ publicationID }) => getBrandTheme(publicationID)}
    }
`;

type TStyledProviderProps = {
    children: React.ReactNode;
    publicationID: TPublication;
}

function shouldForwardProp() {
    return true;
}

export const StyledProvider = ({
    children,
    publicationID,
}: TStyledProviderProps) => (
    <StyleSheetManager shouldForwardProp={ shouldForwardProp }>
        <GlobalStyles publicationID={ publicationID } />
        {children}
    </StyleSheetManager>
);
